module.exports = __webpack_public_path__ + "pc/img/Comp 1_00425 1.828d2ae2.png";